import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeResbuildmngKind from './ChangeResbuildmngKind';
import ChangeResbuildmngBuildinglife from './ChangeResbuildmngBuildinglife';
import ChangeResbuildmngCostcons from './ChangeResbuildmngCostcons';
import ChangeResbuildmngCoverage from './ChangeResbuildmngCoverage';
import ChangeResbuildmngTypeofcons from './ChangeResbuildmngTypeofcons';
import ChangePriceResbuildmng from './ChangePriceResbuildmng';
import ChangeResBossToEmployeeDiscount from "./ChangeResBossToEmployeeDiscount";
import ChangeResBossToEmployeeExtraCoverage from "./ChangeResBossToEmployeeExtraCoverage";
import ChangePriceBossToEmployee from "./ChangePriceBossToEmployee";



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeResBossToEmployee extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div>
                 <AppBar position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                   >

                     <Tab label="پوشش اضافی بیمه نامه "  />
                     <Tab label="تخفیف ها"  />
                     <Tab label="قیمت بیمه"  />
                     </Tabs>


                 </AppBar>

                 {(value===0)?<ChangeResBossToEmployeeExtraCoverage  props={this.props}/>:null}
                 {(value===1)?<ChangeResBossToEmployeeDiscount  props={this.props}/>:null}
                 {(value===2)?<ChangePriceBossToEmployee  props={this.props}/>:null}
            </div>
        );
    }
}

export default  withStyles(styles)(ChangeResBossToEmployee);
